<template>
<!--  <h4 v-if="showTimeRemaining" class="vertical-center mb-0 text-white">{{ timeRemaining }}</h4>-->
  <h4 class="text-right mb-0 text-white">{{ timeRemaining }}</h4>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Countdown',
    props: {
      endHour: {
        type: String,
        required: true,
      },
      endMin: {
        type: String,
        required: true,
      },
      startHour: {
        type: String,
        required: true,
      },
      leaveTime: {
        required: true,
      },
      onCountdownEnds: {
        type: Function,
        required: false,
      },
    },
    data() {
      return {
        showTimeRemaining: false,
        timeRemaining: -1,
        clockIntervalId: '',
        countdownEnded: false,
      };
    },
    mounted() {
      console.log('>> countdown mounted');
      this.fetchTimeRemaining();
      this.pollTimeRemaining();
    },
    beforeDestroy() {
      clearInterval(this.clockIntervalId);
    },
    methods: {
      pollTimeRemaining() {
        this.clockIntervalId = setInterval(() => {
          this.fetchTimeRemaining();
        }, 1000);
      },
      fetchTimeRemaining() {
        // Get time remaining
        const duration = moment.duration(this.leaveTime.diff(moment()));
        const hoursLeft = duration._data.hours;
        const minutesLeft = duration._data.minutes;
        const secondsLeft = duration._data.seconds;

        this.showTimeRemaining = (hoursLeft <= 0 && minutesLeft < 5) || ((hoursLeft <= 0) && (minutesLeft === 5) && (secondsLeft < 1)); // 5 minutes

        const secondsFormat = (secondsLeft < 10) ? `0${secondsLeft}` : secondsLeft;
        this.timeRemaining = `${minutesLeft}:${secondsFormat}`;
        // Check if the countdown has ended
        if (hoursLeft <= 0 && minutesLeft <= 0 && secondsLeft <= 0) {
          console.log('>> countdown ended ', this.countdownEnded);
          console.log('>> onCountdown ended', this.onCountdownEnds);
          if (!this.countdownEnded && this.onCountdownEnds) {
            // Call countdown ended function
            this.onCountdownEnds();
          }
          this.countdownEnded = true;
        }
      },
    },
  };
</script>

<style scoped>

</style>
